<template>
  <div class="container">
    <HeaderView />
    <div :class="{ 'bg-content': $store.state.screenWidth > 375, 'bg-content-se': $store.state.screenWidth <= 375, 'bg-content-4': $store.state.screenWidth <=320 }">
      <div
        class="container"
        style="color: #555555;"
      >
        <div class="row mt-3 mb-3">
          <div
            class="col-12 d-flex justify-content-start align-items-center mb-2"
            style="font-weight: 400;font-size: 22px;color: #555555; font-family: 'Mitr', sans-serif;"
          >
            <i class="ti ti-run"></i>&nbsp;กิจกรรมทั้งหมด
          </div>
          <div class="col-12 row mb-2">
            <div class="col-10">
              <div class="input-icon">
                <input
                  v-model="searchtext"
                  type="text"
                  class="form-control form-control-rounded"
                  placeholder="กรอกชื่อกิจกรรมที่ต้องการค้นหา...."
                >
                <span class="input-icon-addon">
                  <i class="ti ti-search"></i>
                </span>
              </div>
            </div>
            <div class="col-2">
              <router-link
                to="/activity"
                class="btn text-white btn-pill"
                style="background: #805f41; font-family: 'Mitr', sans-serif;"
              ><i
                  class="ti ti-chevron-left"
                  style="font-size: 18px;"
                ></i></router-link>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div
              class="col-sm-3 row mb-2 p-2 border"
              v-for="(ws, i) in filterData"
              :key="'ws' + i"
            >
              <div class="col-auto">
                <span
                  class="avatar"
                  :style="{'background-image': 'url(/static/img/logo/'+ws.fac_logo +')'}"
                ></span>
              </div>
              <div class="col">
                <b class="text-body d-block">{{ ws.workshop_name }}</b>
                <div class="text-muted text-truncate mt-n1">{{ ws.workshop_dep }}</div>
              </div>
            </div>
            <div
              style="width: 100%; height: 100px;"
              v-if="ws_list.length > 2"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderView from './layouts/HeaderView.vue'
import FooterbarView from './layouts/FooterbarView.vue'
import Swal from 'sweetalert2'
import api from '../assets/services'

export default {
  components: {
    HeaderView,
    FooterbarView
  },
  data () {
    return {
      ws_list: [],
      searchtext: ''
    }
  },
  computed: {
    filterData: function () {
      let text = this.searchtext.trim()
      return this.ws_list.filter(workshop => {
        if (workshop.workshop_name !== null) {
          return (
            workshop.workshop_name.indexOf(text) > -1 || workshop.workshop_dep.indexOf(text) > -1
          )
        }
      })
    }
  },
  methods: {
    async getWorkShopList () {
      this.$store.state.isLoading = true
      api.getWorkshop(
        this.$store.state.URL,
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.ws_list = result.data
            this.$store.state.isLoading = false
          } else {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'เข้าสู่ระบบใหม่',
              denyButtonText: 'ยกเลิก'
            }).then((result) => {
              localStorage.clear()
              this.$router.push('/').catch(() => { })
            })
          }
        },
        _error => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        }
      )
    }
  },
  async mounted () {
    const auth = this.callbackToken(this.$store.state.user.citizenId)
    if (auth) {
      await this.checkUser()
      await this.getWorkShopList()
    } else {
      localStorage.clear()
      this.$router.push('/').catch(() => { })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Workshop.vue